import { Grid } from '@mui/material';

export default function CenterScreen({children}) {
    return <Grid container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{minHeight: '100vh'}}>
        <Grid size={3}>
            {children}
        </Grid>
    </Grid>
}
